/* ===========================
IMPORTS
=========================== */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// // IMPORT - COMPONENTS
import BundlesDetails from './Details';
import BundlesApks from './Apks';
// IMPORT - ELEMENTS
// IMPORT - Helpers

/* ===========================
CLASS
=========================== */
class BundlesView extends Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  */
  constructor(props) {
    super(props);
    this.state = {
      id: (this.props.match.params.id || null),
    };

    this.renderSection = this.renderSection.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    // Show the component
    this.props.updateLoadingApp(false);
    this.props.updateLoadingContent(false);
  }

  /**
   * @param {string} section
   */
  renderSection(section) {
    switch (section) {
      case 'details':
        return (<BundlesDetails id={this.props.match.params.id} />);
      case 'apks':
        return (<BundlesApks id={this.props.match.params.id} />);
      default:
        return '';
    }
  }

  /* ===========================
  RENDER
  =========================== */

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col col-12">

            <div className="page-header">
              <h1>
                Bundles
                <span>{(this.state.id) ? `ID ${this.state.id}` : ''}</span>
              </h1>
            </div>

            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col col-12">
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <Link className={`nav-link ${(this.props.match.params.section === 'details') ? 'active' : ''}`} to={`/dashboard/bundles/${this.state.id}/details`}>Details</Link>
                      </li>
                      <li className="nav-item">
                        <Link className={`nav-link ${(this.props.match.params.section === 'apks') ? 'active' : ''}`} to={`/dashboard/bundles/${this.state.id}/apks`}>APKs</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="content-inner">
                  {this.renderSection(this.props.match.params.section)}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
BundlesView.propTypes = {
  match: PropTypes.object,
  updateLoadingApp: PropTypes.func,
  updateLoadingContent: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(BundlesView);
